export const validation = {
  headingMaxChar: 70,
  subTitleMaxChar: 70,
  paragraphMaxChar: 150,
  scrollMaxChar: 150
}
